import React, { useRef, useState, useEffect } from "react";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";

import "./styles.scss";
// import { Container, ReactDatePicker, Error } from './styles';

registerLocale("ptBR", ptBR);

const DatePicker = ({
  name,
  focused = false,
  onChange,
  defaultValue,
  ...rest
}) => {
  const datepickerRef = useRef(null);

  const [date, setDate] = useState(null);

  useEffect(() => {
    if (!defaultValue) {
      setDate(null);
      return;
    }

    setDate(new Date(defaultValue));
  }, [defaultValue]);

  return (
    <div className="datepicker-wrapper">
      <ReactDatePicker
        // className="flex-1 bg-transparent border-none"
        className="datepicker"
        ref={datepickerRef}
        selected={date}
        locale="ptBR"
        dateFormat="dd/MM/yyyy"
        onChange={date => {
          setDate(date);
          onChange(date);
        }}
        preventOpenOnFocus
        showYearDropdown
        dateFormatCalendar="MMMM"
        placeholderText=" -- / -- / --"
        {...rest}
      />
    </div>
  );
};

export default DatePicker;
